import { useRequest } from 'ahooks';
import { getFullPolicy } from '../../../axios/api'

function useGetFullPolicy(){
  const {  data:fullPolicyData, loading:fullPolicyLoading,runAsync:getFullPolicyAction } = useRequest(
    async (params) => {
      try {
        const resp = await getFullPolicy({
          ...params
        });
        return resp?.data ?? undefined
      } catch (error) {
        // message.error('获取知识点失败！');
        return undefined;
      }
    },
    {
      debounceWait: 1,
      manual: true,
    },
  );

    return {
      fullPolicyData,
      fullPolicyLoading,
      getFullPolicyAction
    
    }
}

export default useGetFullPolicy